module.exports = __webpack_public_path__ + "static/media/help_icon.cf4ff059.png";